import { create } from 'zustand';
import { ComercialTableTypes } from '../ManageComercialTable/types';

type State = {
  openModalConsultEditTableRules: boolean;
  selectAllConsultComercialTable: boolean;
  consultComercialProductItemSelectedList: ComercialTableTypes[];
  consultComercialFiltersBody: any;
};

type Actions = {
  setConsultComercialTableState: (name: string, data: any) => void;
  reset: () => void;
};

const initialState: State = {
  openModalConsultEditTableRules: false,
  selectAllConsultComercialTable: false,
  consultComercialProductItemSelectedList: [],
  consultComercialFiltersBody: {},
};

export const useConsultComercialTableStore = create<State & Actions>(set => ({
  ...initialState,
  setConsultComercialTableState: (name, data) => {
    set(() => ({
      [name]: data,
    }));
  },
  reset: () => {
    set(initialState);
  },
}));
